(function(){
  var nav = document.getElementById('cpnav');
  if(nav){
    var items = nav.querySelectorAll('.ni.hm'), t = null, cur = null;
    function close(n){ if(!n) return; n.classList.remove('op'); var a=n.querySelector('a'); if(a) a.setAttribute('aria-expanded','false');
      var m=n.querySelector('.mega'); if(m) setTimeout(function(){ if(!n.classList.contains('op')) m.hidden = true; }, 220); }
    function open(n){ if(cur && cur!==n) close(cur); cur=n; var m=n.querySelector('.mega'); if(m) m.hidden=false;
      requestAnimationFrame(function(){ n.classList.add('op'); }); var a=n.querySelector('a'); if(a) a.setAttribute('aria-expanded','true'); }
    items.forEach(function(n){
      n.addEventListener('mouseenter', function(){ clearTimeout(t); open(n); });
      n.addEventListener('mouseleave', function(){ clearTimeout(t); t=setTimeout(function(){ close(n); if(cur===n) cur=null; }, 130); });
      n.addEventListener('focusin', function(){ clearTimeout(t); open(n); });
    });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape' && cur){ close(cur); cur=null; } });
    document.addEventListener('click', function(e){ if(cur && !cur.contains(e.target)){ close(cur); cur=null; } });
  }

  var b = document.getElementById('cpBurger'), d = document.getElementById('cpDrawer');
  if(b && d){
    /* Menu mobile : il ne doit JAMAIS rester bloque ouvert. */
    function reset(){
      d.hidden = true;
      d.classList.remove('lvl2');
      b.setAttribute('aria-expanded','false');
      document.body.classList.remove('cpd-open');
    }
    b.addEventListener('click', function(){
      var open = d.hidden;
      d.hidden = !open;
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('cpd-open', open);
    });
    /* avant : seul un toucher pile sur le lien fermait le menu ; un toucher sur
       la photo ou le texte de « Nike » laissait le menu ouvert et la page bloquee */
    d.addEventListener('click', function(e){
      var a = e.target.closest('a');
      if(a && a.getAttribute('href') && a.getAttribute('href') !== '#') reset();
    });
    /* retour arriere : le telephone re-affiche la page telle quelle (menu ouvert) */
    window.addEventListener('pageshow', reset);
    window.addEventListener('pagehide', reset);

    /* haut du menu : annonce des nouveautes + tous les crampons + raccourcis par modele */
    if(!d.querySelector('.cpd-top')){
      var first = d.querySelector('details.cpd1w');
      if(first){
        var C = 'https://cdn.shopify.com/s/files/1/1043/0142/9084/files/';
        var MOD = [
          ['Mercurial Vapor','nike-mercurial-vapor','o0166'],
          ['Mercurial Superfly','nike-mercurial-superfly','o0047'],
          ['Phantom','nike-phantom','3feae30542ee'],
          ['Tiempo','nike-tiempo',''],
          ['F50','adidas-f50','b7371d17367a'],
          ['Predator','adidas-predator','6c626b942c1e'],
          ['Copa','adidas-copa','a46e29328a7f'],
          ['Puma Future','puma-future',''],
          ['Puma Ultra','puma-ultra','']
        ];
        var top = document.createElement('div');
        top.className = 'cpd-top';
        top.innerHTML =
            '<a class="cpd-nv" href="/collections/nouveautes-1">'
          +   '<span class="cpd-nv-t"><small>Nouveautés</small><b>Final Rush, Sam Kerr, Phantom 6 Break ’Em</b><i>Voir les nouveautés →</i></span>'
          +   '<span class="cpd-nv-i"><img src="' + C + 'b7371d17367a.jpg?width=300" alt="" loading="lazy"></span>'
          + '</a>'
          + '<a class="cpd-alltop" href="/collections/crampons-de-foot">Voir tous les crampons</a>'
          + '<p class="cpd-mh">Voir tout par modèle</p>'
          + '<div class="cpd-mods">' + MOD.map(function(m){
              return '<a href="/collections/' + m[1] + '">'
                + (m[2] ? '<span><img src="' + C + m[2] + '.jpg?width=200" alt="" loading="lazy"></span>' : '<span class="no"></span>')
                + 'Toutes les ' + m[0] + '</a>';
            }).join('') + '</div>';
        first.parentNode.insertBefore(top, first);
        var st = document.createElement('style');
        st.textContent =
            '.cpd-top{padding:12px 16px 6px}'
          + '.cpd-nv{display:flex;align-items:center;gap:12px;background:#111;color:#fff!important;border-radius:16px;padding:14px 14px 14px 16px;text-decoration:none!important}'
          + '.cpd-nv-t{flex:1;min-width:0}.cpd-nv small{display:block;font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:#6FE3C8;font-weight:700}'
          + '.cpd-nv b{display:block;font-size:15px;line-height:20px;margin:4px 0 6px}.cpd-nv i{font-style:normal;font-size:13px;color:#ddd}'
          + '.cpd-nv-i{flex:0 0 84px;height:64px;background:#fff;border-radius:10px;overflow:hidden;display:flex;align-items:center;justify-content:center}'
          + '.cpd-nv-i img{width:100%;height:100%;object-fit:contain}'
          + '.cpd-alltop{display:flex;align-items:center;justify-content:center;margin:10px 0 4px;height:48px;border-radius:999px;border:1.5px solid #111;color:#111!important;font-weight:600;font-size:15px;text-decoration:none!important}'
          + '.cpd-mh{font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:#707072;font-weight:600;margin:16px 0 8px}'
          + '.cpd-mods{display:grid;grid-template-columns:1fr 1fr;gap:8px}'
          + '.cpd-mods a{display:flex;align-items:center;gap:8px;background:#F5F5F5;border-radius:12px;padding:6px 10px 6px 6px;font-size:13px;font-weight:600;color:#111!important;text-decoration:none!important;line-height:16px}'
          + '.cpd-mods span{flex:0 0 44px;height:34px;background:#fff;border-radius:8px;overflow:hidden;display:flex;align-items:center;justify-content:center}'
          + '.cpd-mods span.no{background:#e9e9e9}.cpd-mods img{width:100%;height:100%;object-fit:contain}'
          + '#cpDrawer.lvl2 .cpd-top{display:none!important}';
        document.head.appendChild(st);
      }
    }
  }
})();
